module.exports = "https://web-assets.ifttt.com/packs/media/icons-v2/turned_off-37307451.svg";